import { render, staticRenderFns } from "./BonusTable.vue?vue&type=template&id=37915b50&scoped=true&"
import script from "./BonusTable.vue?vue&type=script&lang=js&"
export * from "./BonusTable.vue?vue&type=script&lang=js&"
import style0 from "./BonusTable.vue?vue&type=style&index=0&id=37915b50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37915b50",
  null
  
)

export default component.exports